__turbopack_context__.v({
  "author": "Author-module-scss-module__Z91UjG__author",
  "author-container": "Author-module-scss-module__Z91UjG__author-container",
  "avatar": "Author-module-scss-module__Z91UjG__avatar",
  "caption": "Author-module-scss-module__Z91UjG__caption",
});
